import Entity from 'utilities/entity';

class Reflection extends Entity {}

export default new Reflection();
